export default __webpack_public_path__ + "static/images/signature.378fe73f.png";